<template>
  <div class="maillist">
    <div class="search-box">
      <div class="text">通讯录</div>
      <img src="../../assets/index/ic_search.png" alt class="search-icon" @click="search"/>
    </div>
    <div class="latest-box">
      <div class="title-box">
        <div class="title">最近联系人</div>
        <div class="right-box" @click="personList()">
          <div class="tetxs">查看更多</div>
          <img src="../../assets/index/ic_right.png" alt class="right-icon" />
        </div>
      </div>
      <div class="lists-box">
        <div class="items-box" v-for="(items,idx) in contacts" v-if="idx<3" :key="idx">
          <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
          <div class="info-box">
            <div class="username">{{items.name}}</div>
            <div class="phone">{{items.mobile}}</div>
          </div>
          <div class="phone-box" @click="sendMessage(items)">
            <van-icon name="chat" color="#36b374" size="15" :dot="!!items.unreadCount" />
          </div>
          <div class="phone-box" @click="playPhone(items)">
            <div class="times">{{items.timer}}</div>
           <a><img src="../../assets/index/ic_ts_dh.png" alt class="phone-icon" /></a>
          </div>
        </div>
      </div>

    </div>
      <div class="latest-box">
          <div class="title-box">
              <div class="title">会话列表</div>
          </div>
          <div class="lists-box">
              <div class="items-box" v-for="(items,idx) in conversationList" :key="idx" @click="messageHandle(items)">
                  <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
                  <div class="info-box">
                      <div v-if="items.type === 'C2C'" class="username">{{items.userProfile.nick}}</div>
                      <div v-else-if="items.type === 'GROUP'" class="username">{{items.groupProfile.name}}</div>
                      <div class="phone">{{items.lastMessage.messageForShow}}</div>
                  </div>
                  <div class="phone-box">
                      <div class="times">{{items.timer}}</div>
                      <van-icon name="chat" color="#36b374" size="15" :dot="!!items.unreadCount" />
                  </div>
              </div>
          </div>

      </div>
    <div class="province-box">
      <div class="title">组织架构</div>
      <div class="list-box">
        <div
          class="items-box"
          v-for="(items,idx) in list"
          :key="idx"
        >
        <!-- <div
          class="items-box"
          v-for="(items,idx) in list"
          :key="idx"
          @click="ToProvincemaillist(items,idx)"
        > -->
          <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="file-icon" />
          <div class="centertext">{{items.name}}</div>
          <!-- lbw0410 -->
          <!-- <img src="../../assets/index/ic_bm_jt.png" alt class="right-icon" /> -->
          <div class="disable-class">数据维护中，敬请期待...</div>
        </div>
      </div>
      <!-- <div class="list-box spa-items-box">
        <div class="items-box">
          <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="file-icon" />
          <div class="centertext">涉旅企业</div>
          <img src="../../assets/index/ic_bm_jt.png" alt class="right-icon" />
        </div>
      </div> -->
    </div>
     <callPhone ref="callPhone" :combinPhone="combinPhone" :userInfo="userInfo"></callPhone>
  </div>
</template>

<script>
    import callPhone from 'comps/callPhone';
    import mixin from '@/mixins/index';
    import api from 'apis'
    export default {
        components: { callPhone },
        mixins: [mixin],
        data () {
            return {
                list: [],
                enterprises: [],
                combinPhone: 0,
	            userInfo: {}
            }
        },
        computed: {
            contacts () {
                return this.$store.getters['home/contactsList']
            },
	        currentUserInfo () {
                return this.$store.state.home['currentUserInfo']
            },
	        conversationList () {
		        return this.$store.state.instantMessaging['conversationList'].filter(item => item.conversationID.includes('C2C') || item.conversationID.includes('GROUPTIO'))
	        }
        },

        methods: {
            search () {
                this.$router.push({ path: '/searchMail' })

                // window.yyn.invokeJSB(
                //     'openWindow', {
                //         openUrl: `${this.globalApp.getSystemInfo().host}web/#/searchMail`,
                //         isFullScreen: 0,
                //         setTitle: '',
                //         needLoading: 1
                //     },
                //     cb => {
                //         console.log(cb, 'callback');
                //     }
                // );
            },
            personList () {
                // this.$router.push({ path: '/personList' })

                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personList`,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            playPhone (item) {
                this.call(item)
                this.combinPhone = Number(item.mobile);
                this.userInfo = {
                    targetName: item.name,
	                targetId: item.staffCode,
	                userId: this.currentUserInfo.staffCode,
	                name: this.currentUserInfo.name
                };
                this.$refs.callPhone.showBox();
            },
            ToProvincemaillist (item, index) {
                this.$router.push(`/provincemaillist?id=${item.id}&title=${encodeURI(item.name)}`)

                // window.yyn.invokeJSB(
                //     'openWindow', {
                //         openUrl: `${this.globalApp.getSystemInfo().host}web/#/provincemaillist?id=${item.id}&title=${encodeURI(item.name)}`,
                //         isFullScreen: 0,
                //         setTitle: item.name,
                //         needLoading: 1
                //     },
                //     cb => {
                //         console.log(cb, 'callback');
                //     }
                // );
            },
            getindexAddressbook () {
                // api.indexAddressbook().then(res => {
                //     localStorage.setItem('contactsList', JSON.stringify(res.data.units))
                //     this.list = res.data.units
                //     this.enterprises = res.data.enterprises
                // })
                api.addressbookbyid().then(res => {
                    this.list = res.data.units
                    this.enterprises = res.data.enterprises
                })
            },
	        messageHandle (data) {
            let value
            console.log('datadatadatadatadatadata', data)
            if (data.type === 'GROUP') {
              console.log('GROUPGROUPGROUPGROUP', data.type)
              value = {
                targetId: data.conversationID.replace('GROUPTIO-', ''),
                userId: this.currentUserInfo.staffCode,
                currentConversationType: 'GROUP'
              };
            } else {
              console.log('c2cc2cc2cc2cc2cc2cc2c', data.type)

              value = {
                targetId: data.conversationID.replace('C2Cyjg_', ''),
                userId: this.currentUserInfo.staffCode,
                currentConversationType: 'C2C'
              };
            }

            console.log('targetIdtargetIdtargetIdtargetId',value.targetId)

		        let str = [];

		        for (let key in value) {
			        str.push(key + '=' + value[key]);
		        }
		        let query = str.join('&');
		        if (process.env.NODE_ENV === 'development') {
              if (data.type === 'GROUP') {
                console.log('这是群聊啊---------')
                this.$router.push({
                  path: `/personalChat`,
                  query: {
                    targetId: data.conversationID.replace('GROUPTIO-', ''),
                    currentConversationType: 'GROUP'
                  }
                })
              } else {
                console.log('这是单聊啊---------')
                this.$router.push({
                  path: `/personalChat`,
                  query: {
                    targetId: data.conversationID.replace('C2Cyjg_', ''),
                    currentConversationType: 'C2C'
                  }
                })

              }
		        }

		        window.yyn.invokeJSB(
			        'openWindow',
			        {
				        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personalChat?${query}`,
				        isFullScreen: 1,
				        setTitle: '',
				        needLoading: 1
			        },
			        cb => {
				        console.log(cb, 'callback');
			        }
		        );
	        },
	        async sendMessage(item) {
		        if (this.currentUserInfo.name) {
			        await api.importAccount({
				        nick: this.currentUserInfo.name,
				        identifier: `yjg_${this.currentUserInfo.staffCode}`
			        });
		        }
		        if (item.name) {
			        await api.importAccount({
				        nick: item.name,
				        identifier: `yjg_${item.staffCode}`
			        });
		        }
		        let value = {
			        targetId: item.staffCode,
			        userId: this.currentUserInfo.staffCode
		        };
		        let str = [];
		        for (let key in value) {
			        str.push(key + '=' + value[key]);
		        }
		        let query = str.join('&');
		        if (process.env.NODE_ENV === 'development') {
			        this.$router.push({
				        path: `/personalChat?${query}`
			        })
		        }
		        window.yyn.invokeJSB(
			        'openWindow',
			        {
				        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personalChat?${query}`,
				        isFullScreen: 1,
				        setTitle: '',
				        needLoading: 1
			        },
			        cb => {
				        console.log(cb, 'callback');
			        }
		        );
	        }
        },
        mounted () {
          console.log('conversationList++++++++++++++', this.conversationList)
            this.$store.dispatch('home/reLoadContacts')
            this.getindexAddressbook()
            let ts = this
            document.addEventListener('visibilitychange', function () {
              ts.$store.dispatch('home/reLoadContacts')
            });
              console.log('conversationList++++++++++++++', this.conversationList)
        },

        async created () {
            // document.title = '通讯录'
	        const res = await this.$store.dispatch('home/getStaffCode')
	        const data = await api.getSign({
		        identifier: `yjg_${res.staffCode}`
	        });
	        this.tim.login({
		        userID: `yjg_${res.staffCode}`,
		        userSig: data.data
	        }).then(() => {
		        this.$store.commit('instantMessaging/updateCurrentUserRole', 'staff');
	        }).catch(e => {
		        this.$store.commit('instantMessaging/showMessage', {
			        message: '登录即时通信失败',
			        type: 'danger'
		        });
	        });
        },

        beforeCreate () {
            document.title = '通讯录'
        }
    };
</script>

<style scoped lang="less">
.maillist {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background: rgba(251, 251, 251, 1);

  .search-box {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 12px;

    .text {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
    }
    .search-icon {
      width: 15px;
      height: 15px;
    }
  }
  .latest-box {
    margin-bottom: 12px;
    box-sizing: border-box;
    padding: 0 12px;

    .title-box {
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;

      .title {
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
      .right-box {
        display: flex;
        align-items: center;

        .tetxs {
          height: 12px;
          font-size: 12px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
          margin-right: 4px;
        }
        .right-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
    .lists-box {
      overflow: hidden;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      .items-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        height: 68px;
        box-sizing: border-box;
        padding: 16px;
        border-bottom: 1px solid #eeeeee;

        &:last-child {
          border-bottom: none;
        }

        .headimg {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }

        .info-box {
          flex: 1;
          text-align: left;
          .username {
            height: 20px;
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 200px;
          }
          .phone {
            height: 12px;
            font-size: 12px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
          }
        }
        .phone-box {
          display: flex;
          align-items: center;

          .times {
            height: 12px;
            font-size: 12px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
            margin-right: 12px;
          }
          .phone-icon {
            width: 14px;
            height: 16px;
          }
        }
      }
    }
  }
  .province-box {
    box-sizing: border-box;
    padding: 0 12px;
    padding-bottom: 25px;
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
    }
    .list-box {
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      overflow: hidden;
      .items-box {
        height: 67px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 16px;
        border-bottom: 1px solid #eee;

        &:last-child {
          border-bottom: none;
        }

        .file-icon {
          width: 36px;
          height: 36px;
          margin-right: 12px;
          opacity: 0.5; // lbw0410
        }

        .centertext {
          font-size: 16px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          flex: 1;
          text-align: left;
          opacity: 0.5; // lbw0410
        }
        .right-icon {
          width: 9px;
          height: 15px;
        }
        .disable-class{
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    .spa-items-box {
      margin-top: 12px;
    }
  }
}
</style>
